import { render, staticRenderFns } from "./OrganisationList.vue?vue&type=template&id=175ccb26&"
import script from "./OrganisationList.vue?vue&type=script&lang=js&"
export * from "./OrganisationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports